"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCardItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../../utils");
var _ui = require("../../../ui");
var _excluded = ["title", "confirmed"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  padding: 10px;\n  height: 42px;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade2;
});
var StyledStatusIcon = (0, _styledComponents.default)(_ui.StatusIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-left: auto;\n"])));
var InvisibleBlock = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 20px;\n"])));
var UserCardItem = (0, _styledComponents.default)(function (_ref2) {
  var title = _ref2.title,
    confirmed = _ref2.confirmed,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(Wrapper, props, /*#__PURE__*/_react.default.createElement(InvisibleBlock, {
    className: "me-auto"
  }), /*#__PURE__*/_react.default.createElement(_ui.P, {
    className: "text-center"
  }, title), /*#__PURE__*/_react.default.createElement(StyledStatusIcon, {
    confirmed: confirmed
  }));
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &:not(:first-child) {\n    ", "\n  }\n  ", "\n"])), _utils.mediaQuery.lessThan('xl')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        border-top: 1px solid ", ";\n    "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryShade2;
}), _utils.mediaQuery.greaterThan('xl')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      border-top: 1px solid ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.secondaryShade2;
}));
exports.UserCardItem = UserCardItem;